import type { KeywordTrendsSchema } from "app/pages/activation/types/api";

export const ZERO = 0;

export const KEYWORDS_MOVED_UP_FIELDS: (keyof KeywordTrendsSchema)[] = [
    "movedToTopKeywordsLastDate",
    "movedTop3",
    "movedTop10",
    "topKeywordsLastDate",
];

export const KEYWORDS_DECLINING_FIELDS: (keyof KeywordTrendsSchema)[] = [
    "droppedFrom1",
    "droppedToSecondPage",
];

